{
  "title": "Import students with AI",
  "subtitle": "Upload an Excel/CSV student roster — AI will detect the columns for you",
  "overflowWarning": "File exceeds the limit by {{count}} rows — only the first 500 rows were processed. Split the file to import the rest.",
  "steps": {
    "upload": "Upload",
    "mapping": "Check columns",
    "preview": "Preview",
    "result": "Result"
  },
  "upload": {
    "dropHint": "Drag and drop a file here",
    "formats": ".xlsx and .csv supported",
    "browse": "Choose file",
    "analyzing": "Analyzing file...",
    "rejectedFormat": "Only .xlsx or .csv files are supported",
    "error": "Failed to analyze file"
  },
  "mapping": {
    "headerRow": "Header row: row {{row}}",
    "payerModeLabel": "Who pays?",
    "payerMode": {
      "parent": "Parent pays",
      "self_pay": "Student pays for themselves"
    },
    "fields": {
      "studentName": "Full name",
      "nickname": "Nickname",
      "dateOfBirth": "Date of birth",
      "tags": "Tags",
      "payerName": "Payer name",
      "payerPhone": "Payer phone/Zalo",
      "payerEmail": "Payer email"
    },
    "selectPlaceholder": "Choose column...",
    "none": "— (not present)",
    "columnFallback": "Column {{index}}",
    "reapply": "Re-apply",
    "reapplying": "Applying...",
    "next": "Continue",
    "needStudentName": "Pick the Full name column to continue",
    "aiRead": "Read the file: column labels are on row {{row}}, {{count}} data rows found.",
    "payerModeHelp": "Pick “Student pays” when the file has no parent column — an adult class paying for themselves, for example.",
    "sectionColumns": "Columns — matched automatically, change any that look wrong"
  },
  "preview": {
    "ready": "Ready ({{count}})",
    "warning": "With warnings ({{count}})",
    "needsFix": "Needs fixing ({{count}})",
    "dupWarning": "Possible duplicate ({{count}})",
    "col": {
      "row": "Row",
      "studentName": "Student",
      "payer": "Payer",
      "fee": "Fee",
      "status": "Status",
      "action": "Action"
    },
    "statusReady": "Ready",
    "statusWarning": "Warning",
    "statusNeedsFix": "Needs fixing",
    "statusDup": "Possible duplicate",
    "studentNamePlaceholder": "Student name",
    "payerNamePlaceholder": "Payer name",
    "payerPhonePlaceholder": "Phone/Zalo",
    "exclude": "Skip",
    "keepAnyway": "Add anyway",
    "classCapNote": "Importing into a class is capped at 100 students per run.",
    "classCapExceeded": "{{count}} students selected — {{over}} over the cap of 100. Remove some rows to continue.",
    "dupExistingPayer": "Existing profile · client {{name}} ({{phone}})",
    "dupBatchNote": "Matches row {{row}} in the file",
    "dupUseExisting": "Use existing student",
    "dupSkipBatch": "Skip (duplicate in file)",
    "dupCreateNew": "Create new",
    "empty": "No rows found",
    "commitError": "Import failed",
    "back": "Back",
    "willImport": "Will import {{count}} students",
    "commit": "Confirm import",
    "committing": "Importing..."
  },
  "result": {
    "title": "Import complete",
    "created": "Students created",
    "payersCreated": "New payers",
    "payersLinked": "Payers linked",
    "skipped": "Skipped",
    "classSummary": "Added {{count}} students to {{class}}, {{linked}} using an existing profile, {{skipped}} row(s) skipped.",
    "warningsTitle": "{{count}} row(s) imported with warnings",
    "warningsHint": "Usually an unreadable birth date. Open each student to fill it in.",
    "errorsTitle": "{{count}} error(s)",
    "errorLine": "Row {{row}}: {{reason}}",
    "close": "Close"
  }
}
